// @flow
import type { Action } from '~/core/types';
import type { Effect } from 'redux-saga';
import { put, call, takeEvery, select } from 'redux-saga/effects';
import * as api from '~/core/api/assisted-living';
import handleApi from '~/core/state/handle-api';

import { attemptValidateToken, attemptAcceptInvite, acceptInvite, validateToken } from './actions';
import { getUserId } from '../user/selectors';
import { getConfig } from '../config/selectors';
import { getToken } from '../application/selectors';

type InviteSagaPayload = {
    token: string,
    homeName: string
};

const DEAFULT_HOME_NAME = 'Home'; // Maybe put this in config at some point

function* attemptValidateTokenSaga({ payload: { token } }: Action<InviteSagaPayload>): Generator<Effect, *, *> {
    const homeServiceUrl = yield select(getConfig, 'homes:homeServiceUrl');
    const homeServiceApiKey = yield select(getConfig, 'homes:homeServiceApiKey');
    const authToken = yield select(getToken);

    const [response, error] = yield call(
        handleApi(api.validateToken, true, false),
        token,
        homeServiceUrl,
        homeServiceApiKey,
        authToken
    );

    if (error || !response.valid) {
        return yield put(validateToken(new Error('Not Valid')));
    }

    yield put(validateToken());
}

function* attemptAcceptInviteSaga({
    payload: { token, homeName = DEAFULT_HOME_NAME }
}: Action<InviteSagaPayload>): Generator<Effect, *, *> {
    const userId = yield select(getUserId);
    const homeServiceUrl = yield select(getConfig, 'homes:homeServiceUrl');
    const homeServiceApiKey = yield select(getConfig, 'homes:homeServiceApiKey');
    const authToken = yield select(getToken);

    const [, error] = yield call(
        handleApi(api.acceptInvite, true, false),
        token,
        homeName,
        userId,
        homeServiceUrl,
        homeServiceApiKey,
        authToken
    );
    return yield put(error ? acceptInvite(error) : acceptInvite());
}

function* watchAttemptValidateToken(): Generator<Effect, *, *> {
    yield takeEvery(attemptValidateToken, attemptValidateTokenSaga);
}

function* watchAttemptAcceptInviteSaga(): Generator<Effect, *, *> {
    yield takeEvery(attemptAcceptInvite, attemptAcceptInviteSaga);
}

export default [watchAttemptValidateToken, watchAttemptAcceptInviteSaga];



// WEBPACK FOOTER //
// ./src/core/state/connected-care-invite/sagas.js